var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timestamp"},[_vm._v("\n    "+_vm._s(_vm.formattedDate)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }